import END_POINT from 'src/config/endpoints.constants';
import { ApiResponse, ApiResult, getErrorMessage } from '../lib/API';
import { UUID } from '../types';
import axios from 'axios';

export interface RejectCallResult extends ApiResult {
    data?: {
        message: string;
    };
}

export interface RejectCallResponse extends ApiResponse {
    data: null;
}

export interface RejectCallOptions {
    requestId: UUID;
    /**
     * Logged in user id
     */
    participantId: UUID;
}

export default async function rejectCall(options: RejectCallOptions) {
    const result: RejectCallResult = {};
    try {
        const { data: responseData } = await axios.post<RejectCallResponse>(
            END_POINT.REJECT_CALL,
            options,
        );
        if (responseData) {
            if (responseData.code === 0) {
                result.data = {
                    message: responseData.message,
                };
            } else {
                result.error = responseData.message;
            }
        }
    } catch (error) {
        result.error = getErrorMessage(error);
    }
    return result;
}
